import {
    ENQUIRY_AUTO_SUBMIT_STORAGE_KEY,
    ENQUIRY_SESSION_STORAGE_KEY,
} from '../constants';

/** Reads and parses a JSON value from sessionStorage; null when absent or unreadable. */
const readSessionJSON = (key: string): unknown => {
    try {
        const raw = sessionStorage.getItem(key);
        return raw === null ? null : JSON.parse(raw);
    } catch {
        return null;
    }
};

/**
 * Whether a guest's in-page enquiry for the given item is waiting to be
 * auto-submitted now that the auth flow has completed.
 *
 * Submitting an enquiry while logged out saves the form session and an
 * auto-submit flag to sessionStorage, then shows the auth wall; completing
 * auth reloads the document (see `handleAuthRedirect`), after which the
 * enquiry is re-sent from the saved session. Nothing in memory survives that
 * reload, so hosts of the in-page form (e.g. an accordion row) call this on
 * mount to restore any UI state the reload discarded — such as reopening the
 * row the enquiry was sent from, so its confirmation is visible.
 *
 * Modal enquiries are excluded: the auto-submit flow reopens the enquiry
 * modal itself.
 */
export const hasPendingInPageEnquiryAutoSubmit = (
    siteTreeID: number,
): boolean => {
    if (readSessionJSON(ENQUIRY_AUTO_SUBMIT_STORAGE_KEY) !== true) {
        return false;
    }
    const session = readSessionJSON(ENQUIRY_SESSION_STORAGE_KEY);
    if (typeof session !== 'object' || session === null) {
        return false;
    }
    const { siteTreeId, source, isModal } = session as {
        siteTreeId?: unknown;
        source?: unknown;
        isModal?: unknown;
    };
    return siteTreeId === siteTreeID && source === 'InPage' && isModal !== true;
};
